import '../plugins/axios'
import axios from 'axios'
import {DEFAULT_ROOT_URL} from '../helpers/constants'
import {environment} from '../environments/environment'
import Oidc, {InMemoryWebStorage, UserManager, WebStorageStateStore, User, Logger, Log} from 'oidc-client';
import { getCurrentInstance } from 'vue';

export default class AuthService {

  private _userManager: Oidc.UserManager;
  private _user: User | null = null;
  private _config: any = {};

  private pOlsUser:any = sessionStorage.getItem('olsUser')
  public olsUser = this.pOlsUser != null ? JSON.parse(this.pOlsUser) : null;

  private user_locale: string | undefined = "en";

  constructor(){

    this._config = {
      userStore: new Oidc.WebStorageStateStore({store: window.sessionStorage}),  //store: window.sessionStorage; store: new InMemoryWebStorage()
      authority: environment.localhost.domainURL,
      client_id: environment.localhost.client_id,
      redirect_uri: environment.localhost.redirect_uri,
      response_type: environment.localhost.response_type,
      response_mode: environment.localhost.response_mode,
      scope: environment.localhost.scope,
      post_logout_redirect_uri: environment.localhost.post_logout_redirect_uri,
      automaticSilentRenew: false,
      filterProtocolClaims: true,
      loadUserInfo: true,
      ui_locales: this.getLocaleFromUrl()
    };

    this._userManager = new UserManager(this._config);

    // Unconment for detailed console messages
    // Oidc.Log.logger = window.console;
    // Oidc.Log.level = Oidc.Log.DEBUG;

    this._userManager.getUser().then(user => {
      this._user = user;
      this.user_locale = user?.profile?.locale;
    });

  }

  public getUser(): Promise<User | null> {
    return this._userManager.getUser();
  }

  public login(): Promise<void> {
      return this._userManager.signinRedirect();
  }

  public async logout(): Promise<void> {
    
    // https://dev-347llxai.eu.auth0.com/v2/logout?client_id=XXXXXXXXXXXXXXX&returnTo=https://yudriv-olsdrupal.ddev.site:5443/signed-out
      
      return await this._userManager
                        .removeUser()
                        .then(() => {
                          sessionStorage.removeItem('olsUser');
                        })
                        .finally(() => {
                          //window.location.href = environment.localhost.domainURL + '/v2/logout?client_id=' + environment.localhost.client_id + '&returnTo=' + (this.user_locale === 'en' ? environment.localhost.post_logout_redirect_uri : this.addLanguageToUrl(environment.localhost.post_logout_redirect_uri, this.user_locale));
                          window.location.href = environment.localhost.domainURL + '/v2/logout?client_id=' + environment.localhost.client_id + '&returnTo=' + environment.localhost.post_logout_redirect_uri;
                        });            
      }

  public signUp() {
    this.login();
  }

  // #region Methods
  public async authenticationHandler() { //currentInstance: any

    //Get 'code' and 'state' from URL hash response
    const urlParams: any = new URLSearchParams(window.location.search);
    const code: string = urlParams.get('code');
    const state: string = urlParams.get('state');

    // const x = this.getUser().then((user){
    //   return user;
    // });

    return new Promise((resolve, reject) => {
      this._userManager
            .signinRedirectCallback()
            .then(user => {
              window.history.replaceState(
                state,
                window.document.title,
                window.location.origin);

              resolve(user);
              this._user = user;
              //window.location.href = '/';
            })
            .catch(error => {
              // ignore the state error  
              //console.error(error);
            });
    })
  }



  public getAccessToken() {
    if(this.olsUser){
      if(this.olsUser.accessToken){
        return this.olsUser.accessToken;
      }else{
        return "";
      }
    }
  }
  

  public isAuthorized(): boolean {
    const todayTimeStamp = new Date().getTime() / 1000; //get in seconds
    let isAuthorized = true;

    if(this._user){
      if(this._user.profile.exp < todayTimeStamp){
        isAuthorized = false;
      }
    }

    return isAuthorized;
  }

  public emailVerified(): boolean {
    // if(this._user) {
    //   if(this._user.profile) {
    //     return this._user.profile.email_verified;
    //   }
    // }
    return true;
  }

  public redirectToUrl(url: string) {
    return window.location.href = DEFAULT_ROOT_URL + url;
  }

  public async getOlsUserFromApi() {

    if(this._user != null){
      const postObj = {
        //citizenOneUserId: this._user.profile.sub,
        //auth0UserId: this._user.profile.external_id[0].value,
        auth0UserId: this._user.profile.sub,
        email: this._user.profile.email,
        emailVerified: this._user.profile.email_verified,
        userName: this._user.profile.name
      }

      this.getAccessToken();

      await axios
              .post("getOlsUser", postObj)
              .then((response:any) => {
                response.data.userLocale = this.getLocaleFromUrl();
                sessionStorage.setItem("olsUser", JSON.stringify(response.data));
              })
              .catch(error => console.log(error));
    }else{
      console.log("User data missing.")
    }

  }

  public getLocaleFromUrl(): string {
    if (window.location.href.indexOf("/fr") > -1) {
      return "fr"
    }
    else{
      return "en"
    }
  }

  public addLanguageToUrl(url: string, lang: string | undefined) {
    
    lang = lang ?? "en";

    let urlObj = new URL(url);
    let pathSegments = urlObj.pathname.split('/').filter(Boolean); // Remove empty segments

    if (pathSegments[0] !== lang) { 
        pathSegments.unshift(lang); // Add the language if not already present
    }

    urlObj.pathname = '/' + pathSegments.join('/');
    return urlObj.toString();
  }

  //#endregion

}

export const authService = new AuthService();
